import { render, staticRenderFns } from "./RoomBox.vue?vue&type=template&id=53633b2e&scoped=true"
import script from "./RoomBox.vue?vue&type=script&lang=js"
export * from "./RoomBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53633b2e",
  null
  
)

export default component.exports